import clsx from 'clsx';
import { faMessage } from '@fortawesome/pro-light-svg-icons/faMessage';
import { faEye } from '@fortawesome/pro-light-svg-icons/faEye';

import { Icon } from 'src/components';

import i18n from 'src/i18n';
import { convertNumberToCompactFormat } from 'src/utils/convertNumberToCompactFormat';
import { Trending } from './postInformationBar.styles';
import { PostInformationBarProps } from './postInformationBar.types';

const PostInformationBar = ({
  commentsCount = 0,
  viewsCount = 0,
  trending,
  isCommentsEnabled,
  className,
  showDetails,
  onClickComments
}: PostInformationBarProps) => {
  const countPreviews = (count: number) =>
    count === 1 ? i18n.t('feed.previews.preview_one') : i18n.t('feed.previews.preview_other');

  const countComments = (count: number) =>
    count === 1 ? i18n.t('feed.comments.comment_one') : i18n.t('feed.comments.comment_other');

  return (
    <div
      className={clsx('_text-gray-500 _text-1 _d-flex _align-items-center', className)}
      data-test="post-information-bar"
    >
      <div className="_d-flex _align-items-center _mr-4">
        <Icon icon={faEye} size="lg" className="_mr-2" />
        <div className="_text-2">
          {convertNumberToCompactFormat(viewsCount)} {showDetails && countPreviews(viewsCount)}
        </div>
      </div>

      {isCommentsEnabled && (
        <div
          className={clsx('_d-flex _align-items-center _mr-4', {
            '_cursor-pointer': onClickComments
          })}
          onClick={onClickComments}
        >
          <Icon icon={faMessage} size="lg" className="_mr-2" />
          <div className="_text-2">
            {convertNumberToCompactFormat(commentsCount)}{' '}
            {showDetails && countComments(commentsCount)}
          </div>
        </div>
      )}

      {trending && (
        <Trending className="_text-1 _rounded-pill _px-2 _text-red-darkest _bg-red-lightest _d-flex _justify-content-center _align-items-center _text-nowrap">
          🔥 {i18n.t('postInHigh.inHigh')}
        </Trending>
      )}
    </div>
  );
};

export default PostInformationBar;
